import { render, staticRenderFns } from "./Arcade.vue?vue&type=template&id=4e185ad7&scoped=true"
import script from "./Arcade.vue?vue&type=script&lang=js"
export * from "./Arcade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e185ad7",
  null
  
)

export default component.exports